export const billVoidCopy = (billNumber: string) => ({
  title: 'Void bill',
  description: `Void ${billNumber}? This reverses GL and inventory.`,
});

export const invoiceVoidCopy = (invoiceNumber: string) => ({
  title: 'Void invoice',
  description: `Void ${invoiceNumber}? This reverses GL and inventory.`,
});

export const billPaymentVoidCopy = (paymentNumber: string) => ({
  title: 'Void payment',
  description: `Void ${paymentNumber}? This restores bill balances and reverses GL — this cannot be undone.`,
});

export const customerPaymentVoidCopy = (paymentNumber: string) => ({
  title: 'Void payment',
  description: `Void ${paymentNumber}? This restores invoice balances and reverses GL — this cannot be undone.`,
});

export const adjustmentVoidCopy = (adjustmentNumber: string) => ({
  title: 'Void adjustment',
  description: `${adjustmentNumber} — reverses FIFO layer changes and the journal entry.`,
});

export const startingValueVoidCopy = (itemName: string) => ({
  title: 'Void opening stock',
  description: `Void opening stock for ${itemName}? This reverses inventory and the journal entry.`,
});
